import React from "react";
import { Trans } from "react-i18next";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

import Link from "../../Link";
import CountrySelector from "./CountrySelector";
import { INSTANCES, checkInstance } from "../../../utils/featureFlag";
import ZipmexFooterLogo from "../../../assets/svgs/zipmex-logo-footer.svg";

// menu's order: [about-us, mobile, products, support]
const FooterContainer = (props) => {
  const { data, t, lang: currentLanguage, siteCountry, footerMenus } = props;

  const menus = JSON.parse(footerMenus);

  // FIXME: reorganize menus in WP: remove /en in front
  const CustomLink = ({ to, children }) => (
    <Link to={to.replace("/en", "")}>{children}</Link>
  );

  const TRADE_MENUS = [
    { title: `${t("footer.trade.buy")} BTC`, to: "/btc/buy/" },
    { title: `${t("footer.trade.sell")} BTC`, to: "/btc/sell/" },
    { title: `${t("footer.trade.trade")} BTC`, to: "/btc/trade/" },
    { title: `${t("footer.trade.buy")} ETH`, to: "/eth/buy/" },
    { title: `${t("footer.trade.sell")} ETH`, to: "/eth/sell/" },
    { title: `${t("footer.trade.trade")} ETH`, to: "/eth/trade/" },
  ];

  const isShowOnAu = checkInstance([INSTANCES.AU], siteCountry);

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <ZipmexFooterLogo className="footer-logo mb-3" />
              <p className="mb-5 mb-lg-3">{t("footer.zipmex")}</p>
              <CountrySelector currentLanguage={currentLanguage} />

              {isShowOnAu && (
                <>
                  <p className="mb-0">
                    <b>{t("footer.memberOf")}</b>
                  </p>
                  <StaticImage
                    className="mb-5 mb-lg-0"
                    src="../../../assets/images/blockchain_au.png"
                    alt=""
                    formats={["png"]}
                    width={260}
                  />
                </>
              )}
            </div>
            <div className="col-6 col-lg-2">
              <h6>{menus[0].acfMenu.menuTitle}</h6>
              <ul className="footer-menu">
                {menus[0].menuItems.nodes.map((item) => (
                  <li key={`footer-menu-${item.label}-${item.id}`}>
                    <CustomLink to={`${item.url}`}>{item.label}</CustomLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <h6>{menus[1].acfMenu.menuTitle}</h6>
              <ul className="footer-menu">
                {menus[1].menuItems.nodes.map((item) => (
                  <li key={`footer-menu-${item.label}-${item.id}`}>
                    <CustomLink to={`${item.url}`}>{item.label}</CustomLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <h6>{menus[2].acfMenu.menuTitle}</h6>
              <div
                key={`footer-menu-${menus[2].menuItems.nodes[0].label}-${menus[2].menuItems.nodes[0].id}`}
                className="dropdown hover-to-show mb-1"
              >
                <div
                  className="button dropdown-toggle"
                  type="button"
                  id="footer-trade-menu"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ fontSize: "14px" }}
                >
                  {menus[2].menuItems.nodes[0].label}
                </div>
                <div
                  className="dropdown-menu"
                  aria-labelledby="footer-trade-menu"
                >
                  {TRADE_MENUS.map((_menu, i) => (
                    <div className="dropdown-item" key={`${_menu.title}-${i}`}>
                      <CustomLink
                        key={`dropdown-item-${_menu.title}`}
                        to={_menu.to}
                      >
                        {_menu.title}
                      </CustomLink>
                    </div>
                  ))}
                </div>
              </div>
              <ul className="footer-menu">
                {menus[2].menuItems.nodes.slice(1).map((item) => (
                  <li key={`footer-menu-${item.label}-${item.id}`}>
                    <CustomLink to={`${item.url}`}>{item.label}</CustomLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <h6>{menus[3].acfMenu.menuTitle}</h6>
              <ul className="footer-menu">
                {menus[3].menuItems.nodes.map((item) => (
                  <li key={`footer-menu-${item.label}-${item.id}`}>
                    <CustomLink to={`${item.url}`}>{item.label}</CustomLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row pt-lg-5 pt-3">
            <div className="col-lg-6 order-lg-1">
              <ul className="footer-social-links">
                {t("footer.socials", { returnObjects: true }).map(
                  (_social, i) => (
                    <li key={`${_social.name}-${i}`}>
                      <a
                        href={_social.link}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                      >
                        <GatsbyImage
                          image={
                            data[`icon${_social.name}`].childImageSharp
                              .gatsbyImageData
                          }
                          className="footer-social-icon"
                          alt={_social.name}
                          placeholder="blurred"
                        />
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div className="col-lg-6 order-lg-0">
              <p className="copyright-text">
                Copyright &copy; {new Date().getFullYear()}{" "}
                {t("footer.copyright.companyName")}. All Rights Reserved.
              </p>
              {isShowOnAu && (
                <div className="text-center text-lg-left">
                  {t("footer.regulators", { returnObjects: true }).map(
                    ({ title, applications }) => (
                      <React.Fragment key={title}>
                        <p>
                          <b>{title}</b>
                        </p>
                        <ul className="footer-menu">
                          {applications.map(({ name, id }) => (
                            <React.Fragment key={id}>
                              <li>
                                <p className="mb-0">{name}</p>
                              </li>
                              <li>
                                <p>{id}</p>
                              </li>
                            </React.Fragment>
                          ))}
                        </ul>
                      </React.Fragment>
                    )
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="row pt-5">
            <div className="col">
              <p className="copyright-text-alt font-weight-bold mb-1">
                {t(["footer.copyright.title", ""])}
              </p>
              <p className="copyright-text-alt mb-2">
                {t(["footer.copyright.description", ""])}
              </p>
              <p className="copyright-text-alt mb-2">
                {t(["footer.copyright.beforeYouPay", ""])}
              </p>
              <ol className="copyright-text-alt pl-3">
                {t("footer.copyright.awareness", { returnObjects: true }).map(
                  (text, i) => (
                    <li key={`awareness-${i}`}>{text}</li>
                  )
                )}
              </ol>

              {t(["footer.copyright.zipUpAwereness.text1", ""]) && (
                <p className="copyright-text-alt">
                  <Trans
                    i18nKey="footer.copyright.zipUpAwereness.text1"
                    components={[
                      <Link to={t("earn.linkTermsAndConditions")}></Link>,
                    ]}
                  />
                </p>
              )}
              {t(["footer.copyright.zipUpAwereness.text2", ""]) && (
                <p className="copyright-text-alt">
                  {t(["footer.copyright.zipUpAwereness.text2"])}
                </p>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterContainer;
